import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';

const StyledLink = styled("a", ({ $theme, $disabled }) => ({
  textDecoration: "underline",
  cursor: $disabled ? "not-allowed" : void 0,
  color: $disabled ? $theme.colors["text-global-disabled"] : "inherit"
}));

export { StyledLink };
